export const setAuthData = (data) => {
  console.log("setAuthData:---", data);
  localStorage.setItem('authToken', data.token);
  localStorage.setItem('userData', JSON.stringify({
    name: data.user.name,
    email: data.user.email,
    userType: data.user.userType,
    pan_card: data.user.pan_card,
    GSTIN: data.user.GSTIN,
    address: data.user.address || "",
    pincode: data.user.pincode || "",
    bank_name: data.user.bank_name || "",
    account_number: data.user.account_number || "",
    account_holder_name: data.user.account_holder_name || "",
    ifsc_code: data.user.ifsc_code || "",
    cancelled_cheque: data.user.cancelled_cheque || "",
  }));
};

export const getAuthToken = () => {
  return localStorage.getItem("authToken");
};

export const removeAuthToken = () => {
  localStorage.removeItem("authToken");
};
export const getUserData = () => {
  const userData = localStorage.getItem('userData');
  return userData ? JSON.parse(userData) : null;
};

export const removeAuthData = () => {
  localStorage.removeItem('authToken');
  localStorage.removeItem('userData');
};

export const setAuthToken = (token) => {
  console.log("token", token);
  localStorage.setItem('authToken', token);
};

export const getUserDetails = () => {
  const userData = getUserData();
  if (!userData) return null;

  return {
    bank_name: userData.bank_name,
    account_number: userData.account_number,
    account_holder_name: userData.account_holder_name,
    ifsc_code: userData.ifsc_code,
    cancelled_cheque: userData.cancelled_cheque
  };
};


